module.exports = __webpack_public_path__ + "img/type2.a43d2771.png";